import { FETCH_ICONS } from "../types/icons";

export const fetchIcons = () => {
  return dispatch => {
    dispatch({
      type: FETCH_ICONS
    });
  };
};
